import { render, staticRenderFns } from "./power.vue?vue&type=template&id=28e21ba1&scoped=true&"
import script from "./power.vue?vue&type=script&lang=js&"
export * from "./power.vue?vue&type=script&lang=js&"
import style0 from "./power.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./power.vue?vue&type=style&index=1&id=28e21ba1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e21ba1",
  null
  
)

export default component.exports